import { FooterLinkContext as e, defaultLink as t } from "./FooterLinkContext.es.js";
import { jsx as i } from "react/jsx-runtime";
var v = ({ children: o, link: r = t }) => /* @__PURE__ */ i(e.Provider, {
  value: { link: r },
  children: o
});
export {
  v as FooterLinkProvider
};
